"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Project = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectDestructuringEmpty2 = require("babel-runtime/helpers/objectDestructuringEmpty");

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import { FaAt, FaPhone, FaUser } from 'react-icons/fa';


var _ProjectUtil = require("../../utils/ProjectUtil");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxConnect = require("redux-connect");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _projects = require("../../redux/modules/projects");

var _reduxForm = require("redux-form");

var _ProjectUsers = require("../../components/projects/ProjectUsers");

var _ProjectUsers2 = _interopRequireDefault(_ProjectUsers);

var _ads = require("../../redux/modules/ads");

var _RadioGroupInline = require("../../components/form/RadioGroupInline");

var _RadioGroupInline2 = _interopRequireDefault(_RadioGroupInline);

var _AdSearchSelect = require("../../components/ads/AdSearchSelect");

var _AdSearchSelect2 = _interopRequireDefault(_AdSearchSelect);

var _AdsUtil = require("../../utils/AdsUtil");

var _Ad = require("../../components/ads/Ad");

var _Ad2 = _interopRequireDefault(_Ad);

var _ProjectUserForm = require("../../components/projects/ProjectUserForm");

var _ProjectUserForm2 = _interopRequireDefault(_ProjectUserForm);

var _reactDatepicker = require("react-datepicker");

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Project = exports.Project = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Project, _Component);

  function Project() {
    (0, _classCallCheck3.default)(this, Project);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Project.__proto__ || (0, _getPrototypeOf2.default)(Project)).call(this));

    _this.state = {
      isAdmin: false,
      showClosedAdsOnly: false,
      deliveryStartDate: (0, _moment2.default)(),
      deliveryEndDate: (0, _moment2.default)(),
      orderByDeliveryDates: false
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDeliveryStartDateChange = _this.handleDeliveryStartDateChange.bind(_this);
    _this.handleDeliveryEndDateChange = _this.handleDeliveryEndDateChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Project, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      (0, _objectDestructuringEmpty3.default)(this.props);
      var ad_type = this.props.fields.ad_type;
      var adId = this.props.params.adId;
      var id = this.props.params.id;
      var _props = this.props,
          loadProjectInactiveUsers = _props.loadProjectInactiveUsers,
          loadProjectUsers = _props.loadProjectUsers;


      loadProjectUsers(id);
      loadProjectInactiveUsers(id);

      var selectedAd = this.props.ads.find(function (ad) {
        return ad.id === parseInt(adId, 10);
      });

      if (selectedAd && selectedAd.ad_type === "supplierAd") {
        ad_type.onChange("supplierAd");
      }
      this.setMinAndMaxDeliveryDates();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props2 = this.props,
          user = _props2.user,
          projectUsers = _props2.projectUsers,
          projects = _props2.projects;

      this.setState({ isAdmin: (0, _ProjectUtil.isProjectAdmin)(projectUsers, user.id) });
    }
  }, {
    key: "render",
    value: function render() {
      var project = this.props.project;

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Projektit" }),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Projekti "
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Nimi"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.name
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Kuvaus"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.project_description
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Yritys"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.business_name,
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "Y-tunnus "
            ),
            _react2.default.createElement("br", null),
            project.business_id
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Yhteyshenkil\xF6 "
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "Nimi"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.project_owner_name,
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "Puhelin:"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "a",
              { href: "tel:" + project.project_owner_phone },
              project.project_owner_phone
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "S\xE4hk\xF6posti"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "a",
              { href: "mailto:" + project.project_owner_email },
              project.project_owner_email
            )
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Ty\xF6maatiedot"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Ty\xF6numero"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.construction_site_id
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Urakoitsija"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.contractor
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Ty\xF6maan osoite"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.project_site_address,
            " ",
            _react2.default.createElement("br", null),
            project.project_postal_code,
            ", ",
            project.project_postal_area,
            " ",
            _react2.default.createElement("br", null),
            " ",
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              "small",
              null,
              "Yhteyshenkil\xF6"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "Nimi"
            ),
            " ",
            _react2.default.createElement("br", null),
            project.contact_person_name,
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "Puhelin"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "a",
              { href: "tel:" + project.contact_person_phone },
              project.contact_person_phone
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "small",
              null,
              "S\xE4hk\xF6posti"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "a",
              { href: "mailto:" + project.contact_person_email },
              project.contact_person_email
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4" },
            this.renderAddAdButton()
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4" },
            this.renderEditProjectButton()
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4" },
            this.renderEditProjectUsersButton()
          )
        ),
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Ty\xF6maan ilmoitukset"
        ),
        this.renderProjectAds()
      );
    }
  }, {
    key: "renderAddAdButton",
    value: function renderAddAdButton() {
      var _props3 = this.props,
          project = _props3.project,
          user = _props3.user;

      // TODO
      // is_project_editor can add adds

      var is_project_editor = true;

      if (is_project_editor == true) {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(_Button2.default, {
            text: "Lis\xE4\xE4 ilmoitus",
            additionalClasses: "button-set-width",
            onClick: this.handleAdAddButtonClick.bind(this)
          })
        );
      } else {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(
            "p",
            null,
            "Vain admin ja projektik\xE4ytt\xE4j\xE4 voi lis\xE4t\xE4 ilmoituksia"
          )
        );
      }
    }
  }, {
    key: "renderEditProjectButton",
    value: function renderEditProjectButton() {
      if (this.state.isAdmin) {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(_Button2.default, {
            text: "Muokkaa Projektia",
            additionalClasses: "button-set-width",
            onClick: this.hadleEditProjectButtonClick.bind(this)
          })
        );
      } else {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(
            "p",
            null,
            "Vain admin voi muokata projektia"
          )
        );
      }
    }
  }, {
    key: "renderEditProjectUsersButton",
    value: function renderEditProjectUsersButton() {
      var _props4 = this.props,
          project = _props4.project,
          user = _props4.user;

      var is_project_editor = true;

      if (is_project_editor == true) {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(_Button2.default, {
            text: "K\xE4ytt\xE4j\xE4t",
            additionalClasses: "button-set-width",
            onClick: this.hadleEditProjectUsersButtonClick.bind(this)
          })
        );
      } else {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(
            "p",
            null,
            "Vain projektin perustaja voi lis\xE4t\xE4 ilmoituksia"
          )
        );
      }
    }
  }, {
    key: "renederProjectUserForm",
    value: function renederProjectUserForm() {
      var _props5 = this.props,
          project = _props5.project,
          user = _props5.user,
          members = _props5.members,
          params = _props5.params;

      if (project.project_owner_id === user.id) {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(_ProjectUserForm2.default, { members: members, params: params })
        );
      } else {
        return _react2.default.createElement(
          "div",
          { className: "ads-notice" },
          _react2.default.createElement(
            "p",
            null,
            "Vain admin voi lis\xE4t\xE4 j\xE4seni\xE4"
          )
        );
      }
    }
  }, {
    key: "getFilteredAds",
    value: function getFilteredAds() {
      var _props6 = this.props,
          project = _props6.project,
          fields = _props6.fields,
          ads = _props6.ads;

      var filteredAds = (0, _AdsUtil.filterAdsByProjectId)(project.project_id, fields, ads);

      if (this.state.orderByDeliveryDates) {
        filteredAds = (0, _AdsUtil.filterAdsByDeliveryDates)(filteredAds, this.state.deliveryStartDate, this.state.deliveryEndDate);
      }
      return filteredAds;
    }
  }, {
    key: "getAdsTitle",
    value: function getAdsTitle() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Tarjotaan maa-ainesta" : "Vastaanotetaan maa-ainesta";
    }
  }, {
    key: "geDeliveryTitle",
    value: function geDeliveryTitle() {
      var ad_type = this.props.fields.ad_type;

      return ad_type.value === "supplierAd" ? "Tarjotaan" : "Vastaanoton";
    }
  }, {
    key: "handleAdAddButtonClick",
    value: function handleAdAddButtonClick() {
      var project = this.props.project;

      this.props.pushRoute("/jata-ilmoitus/projekti/" + project.project_id);
    }
  }, {
    key: "hadleEditProjectButtonClick",
    value: function hadleEditProjectButtonClick() {
      var project = this.props.project;

      this.props.pushRoute("/projekti/" + project.project_id + "/muokkaa");
    }
  }, {
    key: "hadleEditProjectUsersButtonClick",
    value: function hadleEditProjectUsersButtonClick() {
      var project = this.props.project;

      this.props.pushRoute("/projekti/" + project.project_id + "/kayttajat");
    }
  }, {
    key: "renderNoAdsNotice",
    value: function renderNoAdsNotice() {
      return _react2.default.createElement(
        "div",
        { className: "ads-notice" },
        _react2.default.createElement(
          "p",
          null,
          "Hakuehdoillasi ei l\xF6ytynyt yht\xE4\xE4n ilmoitusta. Muokkaa hakuehtoja ja yrit\xE4 uudelleen."
        )
      );
    }
  }, {
    key: "setMinAndMaxDeliveryDates",
    value: function setMinAndMaxDeliveryDates() {
      var filteredAds = this.getFilteredAds();
      var maxDeliveryDate = new Date(Math.max.apply(null, filteredAds.map(function (e) {
        return new Date(e.delivery_start_date);
      })));

      var minDeliveryDate = new Date(Math.min.apply(null, filteredAds.map(function (e) {
        return new Date(e.delivery_start_date);
      })));

      if (!this.state.orderByDeliveryDates) {
        this.setState({
          deliveryStartDate: (0, _moment2.default)(minDeliveryDate),
          deliveryEndDate: (0, _moment2.default)(maxDeliveryDate)
        });
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === "checkbox" ? target.checked : target.value;
      var name = target.name;
      this.setState((0, _defineProperty3.default)({}, name, value));
    }
  }, {
    key: "handleDeliveryStartDateChange",
    value: function handleDeliveryStartDateChange(date) {
      this.setState({
        deliveryStartDate: date,
        orderByDeliveryDates: true
      });
      this.getFilteredAds();
    }
  }, {
    key: "handleDeliveryEndDateChange",
    value: function handleDeliveryEndDateChange(date) {
      this.setState({
        deliveryEndDate: date,
        orderByDeliveryDates: true
      });
      this.getFilteredAds();
    }
  }, {
    key: "renderAds",
    value: function renderAds() {
      var _props7 = this.props,
          soilTypes = _props7.soilTypes,
          user = _props7.user,
          params = _props7.params;

      var sortedAds = this.getFilteredAds();

      if (!sortedAds.length) {
        return this.renderNoAdsNotice();
      }

      return sortedAds.map(function (ad) {
        if (user) {
          if (ad.activated == false) return null;
          if (ad.visibility == user.company_id || ad.visibility == 0) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        } else {
          if (ad.activated == false) return null;

          if (ad.visibility == 0) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        }
      });
    }
  }, {
    key: "renderClosedAds",
    value: function renderClosedAds() {
      // visibility sisältää yrityksen id:n mille ilmoitus näytetään
      // visibility 0 näytetään kaikille

      var _props8 = this.props,
          soilTypes = _props8.soilTypes,
          user = _props8.user,
          params = _props8.params;

      var sortedAds = this.getFilteredAds();
      if (!sortedAds.length) {
        return this.renderNoAdsNotice();
      }

      return sortedAds.map(function (ad) {
        if (user) {
          if (ad.activated == true) return null;
          if (ad.visibility == user.company_id || ad.visibility == 0) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        } else {
          if (ad.activated == true) return null;

          if (ad.visibility == 0) {
            return _react2.default.createElement(_Ad2.default, {
              key: ad.id,
              ad: ad,
              soilTypes: soilTypes,
              user: user,
              params: params
            });
          }
        }
      });
    }
  }, {
    key: "renderProjectAds",
    value: function renderProjectAds() {
      var _props$fields = this.props.fields,
          ad_type = _props$fields.ad_type,
          postal_area = _props$fields.postal_area,
          soil_type_id = _props$fields.soil_type_id;

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 col-sm-6" },
            _react2.default.createElement(
              "div",
              { className: "checkbox-single" },
              _react2.default.createElement(
                "label",
                null,
                "N\xE4yt\xE4 vain suljetut ilmoitukset:",
                _react2.default.createElement("input", {
                  name: "showClosedAdsOnly",
                  type: "checkbox",
                  checked: this.state.showClosedAdsOnly,
                  onChange: this.handleInputChange
                })
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "ads-type-select" },
              _react2.default.createElement(_RadioGroupInline2.default, {
                name: "ad_type",
                fieldProps: ad_type,
                options: [{
                  id: "receiverAd",
                  value: "receiverAd",
                  title: "Vastaanottavien haku"
                }, {
                  id: "supplierAd",
                  value: "supplierAd",
                  title: "Tarjoavien haku"
                }]
              })
            )
          ),
          _react2.default.createElement("div", { className: "col col-sm-6" })
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_AdSearchSelect2.default, {
              placeholder: "Kaikki maa-ainekset",
              fieldProps: soil_type_id,
              options: this.props.soilTypes
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_start_date" },
              this.geDeliveryTitle(),
              " alku pvm"
            ),
            " ",
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_start_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              selected: this.state.deliveryStartDate,
              onChange: this.handleDeliveryStartDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              maxDate: this.state.deliveryEndDate
              // fieldProps={delivery_start_date}
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-3" },
            _react2.default.createElement(
              "label",
              { htmlFor: "delivery_end_date" },
              this.geDeliveryTitle(),
              " loppu pvm"
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(_reactDatepicker2.default, {
              fixedHeight: true,
              id: "delivery_end_date",
              dateFormat: "D.M.YYYY",
              locale: "fi_FI",
              selected: this.state.deliveryEndDate,
              onChange: this.handleDeliveryEndDateChange,
              placeholderText: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
              minDate: this.state.deliveryStartDate
            })
          ),
          _react2.default.createElement("div", { className: "col col-sm-6" })
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "div",
              { className: "ads-container" },
              _react2.default.createElement(
                "h3",
                { className: "h4 ads-title" },
                this.getAdsTitle()
              ),
              !this.state.showClosedAdsOnly ? this.renderAds() : this.renderClosedAds()
            )
          )
        )
      );
    }
  }]);
  return Project;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  members: _react.PropTypes.object,
  isProjectLoaded: _react.PropTypes.func,
  loadProject: _react.PropTypes.func,
  loadProjectInactiveUsers: _react.PropTypes.func,
  project: _react.PropTypes.object,
  projects: _react.PropTypes.object,
  fields: _react.PropTypes.object.isRequired,
  ads: _react.PropTypes.array.isRequired,
  soilTypes: _react.PropTypes.array.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  userEmail: _react.PropTypes.object,
  projectUsers: _react.PropTypes.array,
  projectInactiveUsers: _react.PropTypes.array
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        id = _ref.params.id;

    var promises = [];
    // here vi load projects
    // pass promised to dispatch
    //  if (!isProjectLoaded(getState())) {
    promises.push(dispatch((0, _projects.loadProject)(id)));
    promises.push(dispatch((0, _projects.loadProjectUsers)(id)));

    //   }
    //   if (!isAdsLoaded(getState())) {
    promises.push(dispatch((0, _ads.loadAds)()));
    //   }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    project: state.projects.project,
    projectUsers: state.projects.projectUsers,
    user: state.auth.user,
    company: state.company.company,
    projects: state.projects.projects,
    ads: state.ads.ads,
    soilTypes: state.ads.soilTypes,
    projectInactiveUsers: state.projects.projectInactiveUsers
  };
}, {
  loadProject: _projects.loadProject,
  isProjectLoaded: _projects.isProjectLoaded,
  loadProjectUsers: _projects.loadProjectUsers,
  loadProjectInactiveUsers: _projects.loadProjectInactiveUsers,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "ads",
  fields: ["ad_type", "postal_area[]", "soil_type_id[]"],
  initialValues: {
    ad_type: "receiverAd"
  }
})(Project)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Projects/Project.js
 ** module id = 1234
 ** module chunks = 0
 **/